<template>
  <div id="presenca-aluno">
    <vuestic-modal
      :ref="'instrutorModal'"
      v-bind:small="false"
      :cancelClass="'none'"
      okText="Fechar"
      cancelText="Fechar"
    >
    <div slot="title">Presença do Instrutor</div>
    <div class="row">
      <div class="col-md-12">
        <!--Tabela-->
        <div class="row">
          <div class="col-md-12">
            <table class="table table-responsive-sm">
              <thead>
                <tr>
                  <th
                    v-for="th in tableInstrutoresOptions.thead"
                    scope="col"
                    :key="th.id"
                  >{{th}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="tableInstrutores.load">
                  <td colspan="3" class="text-center">
                    <div
                      class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                    >
                      <div
                        class="btn-toolbar d-inline-flex"
                        role="toolbar"
                        aria-label="Toolbar with button groups"
                      >
                        <component
                          :animation-duration="1000"
                          :is="'SpringSpinner'"
                          :color="'#4AE387'"
                          :size="80"
                        ></component>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-show="!tableInstrutores.load"
                  v-for="dados in tableInstrutores.data"
                  class="tb-linha"
                  :key="dados.id"
                >
                  <td>{{dados.nome}}</td>
                  <td>{{dados.cpf}}</td>
                  <td>
                    <button
                      title="Registrar Presença"
                      class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                      @click="presencaOpen(dados.cpf)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 15px;padding-left: 3px;"
                      ></span>
                    </button>
                  </td>
                </tr>
                <tr
                  v-show="tableInstrutores.data.length === 0 && !tableInstrutores.load"
                >
                  <td
                    colspan="4"
                    class="text-center"> Nenhum registro encontrado. </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--Tabela-->
      </div>
    </div>
    <br />
  </vuestic-modal>
    <div id="presenca-img" v-show="modal.show">
      <!-- <img id="finger-img"> -->

      <div v-if="cpfDiv" class="col-sm-12 col-lg-12 col-xl-12 justify-content-center">
        <div class="row">
          <div class="text-center" style="width: 100%;">
            <h2>Aulas Teóricas</h2>
          </div>

          <div class="col-md-12">
            <table class="table table-responsive-sm">
              <thead>
                <tr>
                  <th v-for="th in tableOptions.thead" scope="col" :key="th.id">{{th}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="table.load">
                  <td colspan="4" class="text-center">
                    <div class="col-sm-12 col-lg-12 col-xl-12 justify-content-center">
                      <div
                        class="btn-toolbar d-inline-flex"
                        role="toolbar"
                        aria-label="Toolbar with button groups"
                      >
                        <component
                          :animation-duration="1000"
                          :is="'SpringSpinner'"
                          :color="'#4AE387'"
                          :size="80"
                        ></component>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-show="!table.load"
                  v-for="dados in table.data"
                  class="tb-linha"
                  :key="dados.id_turma_teorica"
                >
                  <td>{{utils.formatDate(dados.data_inicio)}}</td>
                  <td>{{utils.formatDate(dados.data_fim)}}</td>
                  <td>
                    <button
                      title="Ver turma"
                      class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                      @click="instrutor(dados.id_turma_teorica)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-user"
                        style="font-size: 20px;padding-left: 3px;"
                      ></span>
                    </button>
                  </td>
                  <td>
                    <button
                      title="Ver turma"
                      class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                      @click="alunos(dados.id_turma_teorica)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-group"
                        style="font-size: 20px;padding-left: 3px;"
                      ></span>
                    </button>
                  </td>

                  <vuestic-modal
                    :show.sync="modalAlunos.show"
                    :ref="'smallModal'+dados.id_turma_teorica"
                    v-bind:small="false"
                    :cancelClass="'none'"
                    okText="Fechar"
                    cancelText="Fechar"
                  >
                    <div slot="title">Presença</div>

                    <div v-show="modalAlunos.load">
                      <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                        <div
                          class="btn-toolbar d-inline-flex"
                          role="toolbar"
                          aria-label="Toolbar with button groups"
                        >
                          <component
                            :animation-duration="1000"
                            :is="'SpringSpinner'"
                            :color="'#4AE387'"
                            :size="80"
                          ></component>
                        </div>
                      </div>
                    </div>
                    <div v-show="!modalAlunos.load">
                      <vuestic-tabs :names="['Regulares', 'Reposição','Intervalo']" ref="tabs">
                        <div slot="Regulares">
                          <div class="row">
                            <div class="col-md-12">
                              <!--Legenda com barra de pesquisa-->
                              <div class="row justify-content-end">
                                <div class="col-md-3">
                                  <fieldset>
                                    <div class="form-group with-icon-left">
                                      <div class="input-group">
                                        <input
                                          @input="debounceInput"
                                          id="search"
                                          autocomplete="off"
                                          required
                                        />
                                        <label class="control-label" for="search">Procurar...</label>
                                        <i class="bar"></i>
                                        <i class="fa icon-left input-icon fa-search"></i>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>
                              <!--Legenda com barra de pesquisa-->

                              <!--Tabela-->
                              <div class="row">
                                <div class="col-md-12">
                                  <table class="table table-responsive-sm">
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="th in tableAlunosOptions.thead"
                                          scope="col"
                                          :key="th.id"
                                        >{{th}}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-show="tableAlunos.load">
                                        <td colspan="3" class="text-center">
                                          <div
                                            class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                                          >
                                            <div
                                              class="btn-toolbar d-inline-flex"
                                              role="toolbar"
                                              aria-label="Toolbar with button groups"
                                            >
                                              <component
                                                :animation-duration="1000"
                                                :is="'SpringSpinner'"
                                                :color="'#4AE387'"
                                                :size="80"
                                              ></component>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="!tableAlunos.load"
                                        v-for="dados in tableAlunos.data"
                                        class="tb-linha"
                                        :key="dados.id_aluno"
                                      >
                                        <td>{{dados.aluno.nome}}</td>
                                        <td>{{dados.aluno.cpf}}</td>
                                        <td>
                                          <button
                                            title="Registrar Presença"
                                            class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                                            @click="presencaOpen(dados.aluno.cpf)"
                                          >
                                            <span
                                              aria-hidden="true"
                                              class="fa fa-check"
                                              style="font-size: 15px;padding-left: 3px;"
                                            ></span>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="tableAlunos.data.length === 0 && !tableAlunos.load"
                                      >
                                        <td
                                          colspan="3"
                                          class="text-center"
                                        >Nenhum registro encontrado.</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!--Botões da paginação-->
                              <div class="row">
                                <div
                                  class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                                >
                                  <div
                                    class="btn-toolbar d-inline-flex"
                                    role="toolbar"
                                    aria-label="Toolbar with button groups"
                                  >
                                    <div class="btn-group" role="group" aria-label="First group">
                                      <button
                                        type="button"
                                        id="first_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="firstPage()"
                                      >
                                        <i class="fa fa-angle-double-left"></i>
                                      </button>
                                      <button
                                        type="button"
                                        id="previous_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="previousPage()"
                                      >
                                        <i class="fa fa-angle-left"></i>
                                      </button>

                                      <button
                                        type="button"
                                        v-for="page in table.pages"
                                        :class="page === table.currentPage ? 'btn btn-primary hide-not-focused-btn focus' : 'btn-nav btn btn-primary hide-not-focused-btn-'"
                                        @click="(page === table.currentPage ? null : pagePaginate(page))"
                                        :key="page.id"
                                      >{{page}}</button>

                                      <button
                                        type="button"
                                        id="next_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="nextPage()"
                                      >
                                        <i class="fa fa-angle-right"></i>
                                      </button>
                                      <button
                                        type="button"
                                        id="last_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="lastPage()"
                                      >
                                        <i class="fa fa-angle-double-right"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--Botões da paginação-->
                              <!--Tabela-->
                            </div>
                          </div>
                          <br />
                          <br />
                        </div>
                        <div slot="Reposição">
                          <div class="row">
                            <div class="col-md-12">
                              <!--Legenda com barra de pesquisa-->
                              <div class="row justify-content-end">
                                <div class="col-md-3">
                                  <fieldset>
                                    <div class="form-group with-icon-left">
                                      <div class="input-group">
                                        <input
                                          @input="debounceInput"
                                          id="search"
                                          autocomplete="off"
                                          required
                                        />
                                        <label class="control-label" for="search">Procurar...</label>
                                        <i class="bar"></i>
                                        <i class="fa icon-left input-icon fa-search"></i>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>
                              <!--Legenda com barra de pesquisa-->

                              <!--Tabela-->
                              <div class="row">
                                <div class="col-md-12">
                                  <table class="table table-responsive-sm">
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="th in tableReposicaoOptions.thead"
                                          scope="col"
                                          :key="th.id"
                                        >{{th}}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-show="tableReposicao.load">
                                        <td colspan="3" class="text-center">
                                          <div
                                            class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                                          >
                                            <div
                                              class="btn-toolbar d-inline-flex"
                                              role="toolbar"
                                              aria-label="Toolbar with button groups"
                                            >
                                              <component
                                                :animation-duration="1000"
                                                :is="'SpringSpinner'"
                                                :color="'#4AE387'"
                                                :size="80"
                                              ></component>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="!tableReposicao.load"
                                        v-for="dados in tableReposicao.data"
                                        class="tb-linha"
                                        :key="dados.id_aluno"
                                      >
                                        <td>{{dados.nome}}</td>
                                        <td>{{dados.cpf}}</td>
                                        <td>
                                          <button
                                            title="Registrar Presença"
                                            class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                                            @click="presencaOpen(dados.cpf)"
                                          >
                                            <span
                                              aria-hidden="true"
                                              class="fa fa-check"
                                              style="font-size: 15px;padding-left: 3px;"
                                            ></span>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="tableAlunos.length === 0 && !tableAlunos.load"
                                      >
                                        <td
                                          colspan="3"
                                          class="text-center"
                                        >Nenhum registro encontrado.</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!--Botões da paginação-->
                              <div class="row">
                                <div
                                  class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                                >
                                  <div
                                    class="btn-toolbar d-inline-flex"
                                    role="toolbar"
                                    aria-label="Toolbar with button groups"
                                  >
                                    <div class="btn-group" role="group" aria-label="First group">
                                      <button
                                        type="button"
                                        id="first_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="firstPage()"
                                      >
                                        <i class="fa fa-angle-double-left"></i>
                                      </button>
                                      <button
                                        type="button"
                                        id="previous_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="previousPage()"
                                      >
                                        <i class="fa fa-angle-left"></i>
                                      </button>

                                      <button
                                        type="button"
                                        v-for="page in table.pages"
                                        :class="page === table.currentPage ? 'btn btn-primary hide-not-focused-btn focus' : 'btn-nav btn btn-primary hide-not-focused-btn-'"
                                        @click="(page === table.currentPage ? null : pagePaginate(page))"
                                        :key="page.id"
                                      >{{page}}</button>

                                      <button
                                        type="button"
                                        id="next_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="nextPage()"
                                      >
                                        <i class="fa fa-angle-right"></i>
                                      </button>
                                      <button
                                        type="button"
                                        id="last_page_alunos"
                                        class="btn-nav btn btn-primary pagination-link-btn"
                                        @click="lastPage()"
                                      >
                                        <i class="fa fa-angle-double-right"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--Botões da paginação-->
                              <!--Tabela-->
                            </div>
                          </div>
                          <br />
                          <br />
                        </div>
                        <div slot="Intervalo">
                          <div class="row">
                            <div class="col-md-12">
                              <!--Tabela-->
                              <div class="row">
                                <div class="col-md-12">
                                  <table class="table table-responsive-sm">
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="th in tableIntervaloOptions.thead"
                                          scope="col"
                                          :key="th.id"
                                        >{{th}}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-show="tableIntervalo.load">
                                        <td colspan="3" class="text-center">
                                          <div
                                            class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                                          >
                                            <div
                                              class="btn-toolbar d-inline-flex"
                                              role="toolbar"
                                              aria-label="Toolbar with button groups"
                                            >
                                              <component
                                                :animation-duration="1000"
                                                :is="'SpringSpinner'"
                                                :color="'#4AE387'"
                                                :size="80"
                                              ></component>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="!tableIntervalo.load"
                                        v-for="dados in tableIntervalo.data"
                                        class="tb-linha"
                                        :key="dados.id"
                                      >
                                        <td>{{dados.aluno.nome}}</td>
                                        <td>{{dados.aluno.cpf}}</td>
                                        <td>
                                          <button
                                            title="Registrar Presença"
                                            class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                                            @click="presencaOpen(dados.aluno.cpf)"
                                          >
                                            <span
                                              aria-hidden="true"
                                              class="fa fa-check"
                                              style="font-size: 15px;padding-left: 3px;"
                                            ></span>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr
                                        v-show="tableIntervalo.data.length === 0 && !tableIntervalo.load"
                                      >
                                        <td
                                          colspan="3"
                                          class="text-center"
                                        >Todas as presenças do intervalo foram registradas!</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                        </div>
                      </vuestic-tabs>
                      <span style="color:red"> <b> **O instrutor deve ser o primeiro a entrar e o ultimo a sair </b> </span>
                    </div>
                  </vuestic-modal>
                </tr>
                <tr v-show="table.data.length === 0 && !table.load">
                  <td colspan="3" class="text-center">Nenhum registro encontrado.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr><br>
        <!-- <div class="row">
          <div class="text-center" style="width: 100%;">
            <h2>Aulas Práticas</h2>
          </div>

          <div class="col-md-12">
            <table class="table table-responsive-sm">
              <thead>
                <tr>
                  <th v-for="th in tablePraticaOptions.thead" scope="col" :key="th.id">{{th}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="tablePratica.load">
                  <td colspan="4" class="text-center">
                    <div class="col-sm-12 col-lg-12 col-xl-12 justify-content-center">
                      <div
                        class="btn-toolbar d-inline-flex"
                        role="toolbar"
                        aria-label="Toolbar with button groups"
                      >
                        <component
                          :animation-duration="1000"
                          :is="'SpringSpinner'"
                          :color="'#4AE387'"
                          :size="80"
                        ></component>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-show="!tablePratica.load"
                  v-for="dados in tablePratica.data"
                  class="tb-linha"
                  :key="dados.id_turma_teorica"
                >
                  <td>{{utils.formatDate(dados.data_aula)}}</td>
                  <td>{{dados.instrutor.nome}}</td>
                  <td>{{dados.aluno.nome}}</td>
                  <td>
                    <button
                      title="Presença Instrutor"
                      class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                      @click="presencaOpen(dados.instrutor.cpf)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-pencil"
                        style="font-size: 20px;padding-left: 3px;"
                      ></span>
                    </button>
                    <button
                      title="Presença Aluno"
                      class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                      @click="presencaOpen(dados.aluno.cpf)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-user"
                        style="font-size: 20px;padding-left: 3px;"
                      ></span>
                    </button>
                  </td>
                </tr>
                <tr v-show="tablePratica.data.length === 0 && !tablePratica.load">
                  <td colspan="3" class="text-center">Nenhum registro encontrado.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
      </div>
      <br>
      <div v-if="fingerprint" class="col-sm-12 col-lg-12 col-xl-12">
        <div class="row text-center justify-content-center">
          <img height="200" width="200" src="~assets/fingerprint.png" />
        </div>
        <br />
        <div class="row text-center justify-content-center">
          <h1>Insira sua Digital</h1>
        </div>
      </div>
      <vuestic-modal
        id="modal-photo"
        ref="photoModal"
        :cancelClass="'none'"
        :okClass="'none'"
        :closeIconShown="false"
      >
        <div class="col-sm-12 col-lg-12 col-xl-12">
          <div class="row justify-content-center text-center">
            <div class="col-md-6">
              <img id="mask" height="250" width="250" src="~assets/mask.png" />
              <video id="player" width="250" height="250" autoplay></video>
              <button @click="captureSnapshot" id="capture" class="btn btn-primary">Capturar</button>
            </div>
            <div class="col-md-6">
              <canvas id="snapshot" width="250" height="250"></canvas>
              <button @click="sendSnapshot" id="send" class="btn btn-primary" disabled>Enviar</button>
            </div>
          </div>
        </div>
      </vuestic-modal>
    </div>
    <div id="presenca-load" v-show="modal.load" class="text-center justify-content-center">
      <div class="col-sm-12 col-lg-12 col-xl-12 text-center justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SemipolarSpinner'"
          :color="'#4AE387'"
          :size="289"
        ></component>
      </div>
    </div>
    <vuestic-modal
      id="modal-user"
      ref="smallModal"
      :cancelClass="'none'"
      :okClass="'none'"
      :closeIconShown="false"
    >
      <div>
        <div slot="Dados Básicos">
          <div class="col-md-12 modal-text">
            <img id="avatar-img" height="200" width="200" :src="'data:image/jpg;base64, ' + fotoTirada">
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 modal-text">
              <strong id="tipo-presenca" class="font-weight-bold"> </strong>
            </div>
            <div class="col-md-6 modal-text">
              <strong class="font-weight-bold">CPF:</strong>
              <br />
              {{modal.conteudo.cpf}}
            </div>
            <div class="col-md-6 modal-text">
              <strong class="font-weight-bold">Nome:</strong>
              <br />
              {{modal.conteudo.nome}}
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 modal-text">
              <strong class="font-weight-bold">Aula</strong>
            </div>
            <div id="timestamp" class="col-md-12 modal-text"></div>
          </div>
          <br />
          <!-- <div class="col-md-12 modal-text">
                        <img id="finger-img" height="800" width="384">
          </div>-->
          <div class="row">
            <div class="col-md-12" style="text-align: center; font-size: 25px;">
              <img height="30" width="30" src="~assets/check.png" /> Presença Confirmada  {{ modal.conteudo.tipoPresenca }}
            </div>
          </div>
        </div>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import PresencaController from './PresencaController'
import TurmasController from '../turmas/TurmasController'
import BiometricsController from './BiometricsController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import utils from '../../services/utils'

window._ = require('lodash')

export default {
  components: {
    ...spinners,
    InputIconGroup,
    urlApi
  },
  data () {
    return {
      instrutorSemPresenca: false,
      online: false,
      tableAlunosOptions: { thead: ['Nome', 'CPF', '-'] },
      tableInstrutoresOptions: { thead: ['Nome', 'CPF', '-'] },
      tableIntervaloOptions: { thead: ['Nome', 'CPF', '-'] },
      tableReposicaoOptions: { thead: ['Nome', 'CPF', '-'] },
      tableReposicao: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      tableIntervalo: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      tableInstrutores: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      tableAlunos: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      search: '',
      idTurma: '',
      tableOptions: { thead: ['Início', 'Fim','Instrutor','Alunos'] },
      tablePraticaOptions: { thead: ['Início', 'Instrutor', 'Aluno', '-'] },
      url: urlApi + '/turmas/presencas',
      urlPratica: urlApi + '/aulas/praticas/presencas',
      urlAlunos: urlApi + '/alunos/paginacao',
      urlAlunosReposicao: urlApi + '/alunos/reposicao/paginacao',
      urlInstrutores: urlApi + '/instrutores/paginacao',
      table: {
        data: '',
        load: true
      },
      tablePratica: {
        data: '',
        load: true
      },
      modal: {
        show: true,
        load: false,
        conteudo: {}
      },
      modalInstrutor: {
        show:true,
        load:false,
        conteudo: {},
      },
      modalAlunos: {
        show: true,
        load: false,
        conteudo: {}
      },
      usbButton: true,
      device: '',
      blob: '',
      usbTentativas: 0,
      fotoTentativas: 0,
      fingerprint: false,
      photo: false,
      cpfDiv: true,
      cpfInput: '',
      cpfType: '',
      utils: utils,
      stream: '',
      reload: '',
      fotoTirada: '',
    }
  },
  mounted (event) {
    let self = this
    self.$emit('onPresenca', false)

    self.loadTurmas()

    // self.loadPraticas();

    self.reload = setTimeout(function () {
      window.location.reload(1)
    }, 300000)
  },
  destroyed (event) {
    this.$emit('onPresenca', true)
  },
  methods: {
    callbackDataPaginate (response) {
      this.modalAlunos.load = false
      let responseData = response.data
      this.tableAlunos.currentPage = responseData.current_page
      this.tableAlunos.data = responseData.data
      this.tableAlunos.firstPageUrl = responseData.first_page_url
      this.tableAlunos.from = responseData.from
      this.tableAlunos.lastPage = responseData.last_page
      this.tableAlunos.lastPageUrl = responseData.last_page_url
      this.tableAlunos.nextPageUrl = responseData.next_page_url
      this.tableAlunos.path = responseData.path
      this.tableAlunos.perPage = responseData.per_page
      this.tableAlunos.prevPageUrl = responseData.prev_page_url
      this.tableAlunos.to = responseData.to
      this.tableAlunos.total = responseData.total

      this.tableAlunos.pages = []
      for (let i = 1; i <= responseData.last_page; i++) {
        this.tableAlunos.pages.push(i)
      }

      document.getElementById('previous_page_alunos').disabled = false
      document.getElementById('first_page_alunos').disabled = false

      document.getElementById('next_page_alunos').disabled = false
      document.getElementById('last_page_alunos').disabled = false
      if (responseData.current_page === 1) {
        document.getElementById('previous_page_alunos').disabled = true
        document.getElementById('first_page_alunos').disabled = true
      }

      if (responseData.current_page === responseData.last_page) {
        document.getElementById('next_page_alunos').disabled = true
        document.getElementById('last_page_alunos').disabled = true
      }
      this.tableAlunos.load = false
    },
    callbackDataPaginateInstrutores (response) {
      this.modalAlunos.load = false
      let responseData = response.data
      this.tableInstrutores.currentPage = responseData.current_page
      this.tableInstrutores.data = responseData.data
      this.tableInstrutores.firstPageUrl = responseData.first_page_url
      this.tableInstrutores.from = responseData.from
      this.tableInstrutores.lastPage = responseData.last_page
      this.tableInstrutores.lastPageUrl = responseData.last_page_url
      this.tableInstrutores.nextPageUrl = responseData.next_page_url
      this.tableInstrutores.path = responseData.path
      this.tableInstrutores.perPage = responseData.per_page
      this.tableInstrutores.prevPageUrl = responseData.prev_page_url
      this.tableInstrutores.to = responseData.to
      this.tableInstrutores.total = responseData.total

      this.tableInstrutores.pages = []
      for (let i = 1; i <= responseData.last_page; i++) {
        this.tableInstrutores.pages.push(i)
      }

      this.tableInstrutores.load = false
    },
    callbackDataIntervalo (response) {
      this.modalAlunos.load = false
      this.tableIntervalo.data = response.data
      this.tableIntervalo.load = false
    },
    loadPraticas () {
      let self = this
      self.tablePratica.load = true
      self.$http
        .get(self.urlPratica)
        .then(function (response) {
          console.log(response)
          self.tablePratica.data = response.data.dados
          self.tablePratica.load = false
        })
        .catch(function (err) {
          console.log(err)
          self.tablePratica.load = false
        })
    },
    loadTurmas () {
      let self = this
      self.table.load = true
      self.$http
        .get(self.url)
        .then(function (response) {
          console.log(response)
          self.table.data = response.data.dados
          self.table.load = false
        })
        .catch(function (err) {
          console.log(err)
          self.table.load = false
        })
    },
    callbackDataReposicao (response) {
      this.modalAlunos.load = false
      this.tableReposicao.data = response.data
      this.tableReposicao.load = false
    },
    alunos: function (idTurma) {
      let self = this

      if (!self.idTurma) {
        self.idTurma = idTurma
      }

      try { self.$refs['smallModal' + self.idTurma][0].open() } catch (err) {}

      self.modalAlunos.load = true
      self.$http.get(self.urlAlunos + '/' + self.idTurma + '?search=' + self.search).then(self.callbackDataPaginate)
      self.$http.get(self.urlAlunosReposicao + '/' + self.idTurma).then(self.callbackDataReposicao)
      self.$http.get(self.urlInstrutores + '/' + self.idTurma + '?search=' + self.search).then(self.callbackDataPaginateInstrutores)
      self.$http.get(self.urlAlunos + '/' + self.idTurma + '/intervalo').then(self.callbackDataIntervalo)
    },

    instrutor: function (idTurma) {
      let self = this

      if (!self.idTurma) {
        self.idTurma = idTurma
      }

      self.$http.get(self.urlInstrutores + '/' + self.idTurma + '?search=' + self.search).then(self.callbackDataPaginateInstrutores)

      self.modalInstrutor.load = true;
      try { self.$refs.instrutorModal.open() } catch (err) {}

    },

    nextPage () {
      this.tableAlunos.load = true
      this.$http
        .get(this.tableAlunos.nextPageUrl + '&search=' + this.search)
        .then(this.callbackDataPaginate)
    },
    previousPage () {
      this.tableAlunos.load = true
      this.$http
        .get(this.tableAlunos.prevPageUrl + '&search=' + this.search)
        .then(this.callbackDataPaginate)
    },
    firstPage () {
      this.tableAlunos.load = true
      this.$http
        .get(this.tableAlunos.firstPageUrl + '&search=' + this.search)
        .then(this.callbackDataPaginate)
    },
    lastPage () {
      this.tableAlunos.load = true
      this.$http
        .get(this.tableAlunos.lastPageUrl + '&search=' + this.search)
        .then(this.callbackDataPaginate)
    },
    pagePaginate (page) {
      this.tableAlunos.load = true
      this.$http
        .get(
          this.urlAlunos +
            '/' +
            self.idTurma +
            '?search=' +
            this.search +
            '&page=' +
            page
        )
        .then(this.callbackDataPaginate)
    },
    loadData (cpf) {
      let self = this

      if (self.stream) {
        self.stream.getTracks().forEach(function (track) {
          track.stop()
        })
      }

      if (self.cpfType === 'aluno') {
        console.log('entrou aqui')
        PresencaController.getDataAlunoByCPF(cpf, function (response) {
          self.online = true
          if (response.data.sucesso == false) {
            self.usbTentativas = 0
            self.fotoTentativas = 0

            PresencaController.launchToast('fa-times', response.data.dados)
          } else {
            console.log('enviada')
            self.modal.conteudo = response.data.dados
            document.getElementById('timestamp').innerHTML = self.getTime()
            document.getElementById('tipo-presenca').innerHTML = 'Aluno'
            self.$refs.smallModal.open()
            self.usbTentativas = 0
            self.fotoTentativas = 0
            self.fotoTirada = response.data.dados.fotoPresenca ? response.data.dados.fotoPresenca : response.data.dados.photoApp
            setTimeout(function () {
              self.$refs.smallModal.close()
            }, 5000)
          }
        })
      } else if (self.cpfType === 'instrutor') {
        PresencaController.getDataInstrutorByCPF(cpf,self.idTurma, function (response) {
          self.online = true
          if (response.data.sucesso == false) {
            self.usbTentativas = 0
            self.fotoTentativas = 0
            PresencaController.launchToast('fa-times', response.data.dados)
          } else {
            self.modal.conteudo = response.data.dados
            document.getElementById('timestamp').innerHTML = self.getTime()
            document.getElementById('tipo-presenca').innerHTML = 'Instrutor'
            self.$refs.smallModal.open()
            self.usbTentativas = 0
            self.fotoTentativas = 0
            self.fotoTirada = response.data.dados.fotoPresenca ? response.data.dados.fotoPresenca : response.data.dados.photoApp
            setTimeout(function () {
              self.$refs.smallModal.close()
            }, 5000)
          }
        })
      }

      self.cpfDiv = true
      self.fingerprint = false
      self.photo = false
      self.$data.modal.show = !self.$data.modal.show
      self.$data.modal.load = !self.$data.modal.load
    },

    debounceInput: _.debounce(function (e) {
      this.search = e.target.value
      this.alunos()
    }, 1000),

    getTime () {
      var date = new Date()
      var month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var now =
        date.getDate() +
        '-' +
        month +
        '-' +
        date.getFullYear() +
        ' | ' +
        date.getHours() +
        ':' +
        date.getMinutes() +
        ':' +
        date.getSeconds()
      return now
    },

    async getDevice () {
      let self = this
      self.usbButton = false
      self.device = await BiometricsController.init()
      await self.getFrame(self.device)
    },
    async getFrame (device) {
      let self = this
      self.cpfDiv = false
      self.photo = false
      self.fingerprint = true
      BiometricsController.getImage(device).then(
        function (imageData) {
          self.$data.modal.show = !self.$data.modal.show
          self.$data.modal.load = !self.$data.modal.load
          self.processFinger(imageData)
        },
        function (err) {
          self.getFrame(device)
        }
      )
    },

    async processFinger (arrFinger) {
      let self = this

      self.loadData(self.cpfInput)
      return

      const ws = await new WebSocket('ws://52.67.248.176:5678//')

      ws.onopen = function () {
        self.online = true
        ws.send(['FINGER_1', arrFinger])
      }

      ws.onmessage = function (event) {
        console.log(event.data)
        if (event.data === 'PROCESS_FINGER1_OK') {
          ws.send(['FINGER_2', self.dig1])
        } else if (event.data == 'MATCH') {
          self.loadData(self.cpfInput)
          ws.close(1000, 'Closing...')
        } else if (event.data == 'NO_MATCH') {
          self.$data.modal.show = !self.$data.modal.show
          self.$data.modal.load = !self.$data.modal.load
          self.cpfDiv = true
          self.fingerprint = false
          self.photo = false
          PresencaController.launchToast('fa-times', 'Erro de Leitura!')
          ws.close(1000, 'Closing...')
        }
      }

      ws.onerror = function (event) {
        self.online = false
        self.$data.modal.show = true
        self.$data.modal.load = false
        self.cpfDiv = true
        self.fingerprint = false
        self.photo = false
        PresencaController.launchToast('fa-times', 'Erro')
        console.log(event)
        ws.close(1000, 'Closing...')
      }

      // const nWidth = 379;
      // const nHeight = 150;
      // // var buffer = new Uint8ClampedArray(nWidth * nHeight * 4);

      // // console.log(arrFinger)

      // // for(let i = 0; i < arrFinger.length; i++){
      // //     buffer[i] = arrFinger[i]
      // // }

      // var canvas = document.createElement('canvas')
      // var ctx = canvas.getContext('2d');

      // canvas.width = nWidth;
      // canvas.height = nHeight;

      // // create imageData object
      // var idata = ctx.createImageData(nWidth, nHeight);

      // let i = 0
      // for(var y = 0; y < nHeight; y++) {
      //     for(var x = 0; x < nWidth; x++) {
      //         var pos = (y * nWidth + x) * 4; // position in buffer based on x and y
      //         idata.data[pos  ] = arrFinger[pos];         // some R value [0, 255]
      //         idata.data[pos+1] = arrFinger[pos+1];        // some G value
      //         idata.data[pos+2] = arrFinger[pos+2];       // some B value
      //         idata.data[pos+3] = 255;           // set alpha channel
      //         i++;

      //         // buffer[pos  ] = arrFinger[pos];         // some R value [0, 255]
      //         // buffer[pos+1] = arrFinger[pos+1];        // some G value
      //         // buffer[pos+2] = arrFinger[pos+2];       // some B value
      //         // buffer[pos+3] = 255;           // set alpha channel
      //     }
      // }

      // // idata.data.set(buffer);

      // ctx.putImageData(idata, 0, 0);

      // document.getElementById('finger-img').src = canvas.toDataURL();

      // self.loadDataAluno(1);
    },

    processPhoto () {
      let self = this
      navigator.mediaDevices
        .getUserMedia({ video: { width: 250, height: 250 } })
        .then(function (stream) {
          self.stream = stream
          document.getElementById('player').srcObject = stream

          self.fingerprint = false
          self.$refs.photoModal.open()
        })
        .catch(function (err) {
          console.log(err)
        })
    },

    captureSnapshot () {
      var snapshotCanvas = document.getElementById('snapshot')
      snapshotCanvas
        .getContext('2d')
        .drawImage(document.getElementById('player'), 0, 0, 250, 250)
      document.getElementById('send').disabled = false
    },

    sendSnapshot () {
      let self = this

      self.$refs.photoModal.close()

      self.$data.modal.show = !self.$data.modal.show
      self.$data.modal.load = !self.$data.modal.load

      var data = {
        foto: document.getElementById('snapshot').toDataURL(),
        cpf: self.cpfInput
      }

      PresencaController.sendSnapshot(data, function (response) {
        var size = response.data.dados[1]
        var conf = response.data.dados[2]

        console.log('Conf: ' + conf ** 2 / size)
        console.log('Size: ' + size)

        // self.loadData(self.cpfInput);

        //  PresencaController.launchToast('fa-check', lim)

        if (conf != NaN && size != 'n') {
          self.loadData(self.cpfInput)
        } else {
          PresencaController.launchToast('fa-times', 'NENHUM ROSTO IDENTIFICADO!')
          self.$data.modal.show = !self.$data.modal.show
          self.$data.modal.load = !self.$data.modal.load
          // self.loadData(self.cpfInput)
        }
      })

      // var formData = new FormData();
      // document.getElementById('snapshot').toBlob(function(blob){

      //     formData.append('foto', blob, 'foto.png');
      //     formData.append('cpf', document.getElementById('cpf').value);
      //     formData.append('tipo', self.entidade);

      // });
    },

    presencaOpen (cpf) {
      let self = this

      try {
        self.$refs['smallModal' + self.idTurma][0].close()
      } catch (error) {
        console.error(error)
      }

      self.$http
        .post(urlApi + '/cfc/cpf', { cpf: cpf })
        .then(function (response) {
          self.online = true
          self.cpfInput = cpf
          self.cpfType = response.data.dados.type

          self.processPhoto()

          // self.dig1 = response.data.dados.dig1

          // self.cpfDiv = false
          // self.photo = false
          // self.fingerprint = true
          // self.$data.modal.show = !self.$data.modal.show
          // self.$data.modal.load = !self.$data.modal.load

          // self.loadData(self.cpfInput)

          // self.getDevice();
        })
        .catch(function (error) {
          console.log(error)
          PresencaController.launchToast('fa-times', error.data.dados)
        })
    }
  }
}
</script>

<style type="text/css">
.circle {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  display: inline-block;
}

#presenca-load {
  margin-top: 300px;
  margin-right: 284px;
}

#presenca-img {
  margin-top: 300px;
  margin-right: 284px;
}

.button-presenca {
  margin-right: 50px;
}

#avatar-img {
  border: 10px solid #ddd;
  border-radius: 20px;
  padding: 10px;
}

#finger-img {
  border: 10px solid #ddd;
  border-radius: 20px;
  padding: 10px;
}

.modal-text {
  text-align: center;
  font-size: 50px;
}

#player {
  position: relative;
}

#mask {
  position: absolute;
  z-index: 900;
}
</style>
